document.documentElement.classList.remove('no-js');

const headers = document.querySelectorAll('[data-site-header]');

headers.forEach((header) => {
  const toggle = header.querySelector('[data-mobile-nav-toggle]');
  const panel = header.querySelector('[data-mobile-nav-panel]');
  const closeButton = header.querySelector('[data-mobile-nav-close]');
  const searchToggles = header.querySelectorAll('[data-search-toggle]');
  const searchDropdown = header.querySelector('[data-search-dropdown]');
  const searchInput = header.querySelector('[data-search-input]');

  const closeSearch = ({ returnFocus = false } = {}) => {
    if (!searchDropdown) {
      return;
    }

    header.classList.remove('is-search-open');
    searchDropdown.hidden = true;
    searchToggles.forEach((searchToggle) => {
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.setAttribute('aria-label', 'Open search');
    });

    if (returnFocus && searchToggles[0]) {
      searchToggles[0].focus();
    }
  };

  const openSearch = (activeToggle) => {
    if (!searchDropdown) {
      return;
    }

    if (toggle && panel) {
      closeMenu();
    }
    header.classList.add('is-search-open');
    searchDropdown.hidden = false;
    searchToggles.forEach((searchToggle) => {
      searchToggle.setAttribute('aria-expanded', 'true');
      searchToggle.setAttribute('aria-label', 'Close search');
    });

    if (searchInput) {
      searchInput.focus();
    } else if (activeToggle) {
      activeToggle.focus();
    }
  };

  if (!toggle || !panel) {
    if (searchDropdown && searchToggles.length) {
      searchToggles.forEach((searchToggle) => {
        searchToggle.addEventListener('click', () => {
          if (header.classList.contains('is-search-open')) {
            closeSearch({ returnFocus: true });
            return;
          }

          openSearch(searchToggle);
        });
      });

      document.addEventListener('click', (event) => {
        if (!header.classList.contains('is-search-open')) {
          return;
        }

        if (header.contains(event.target)) {
          return;
        }

        closeSearch();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
          closeSearch({ returnFocus: true });
        }
      });
    }

    return;
  }

  const getFirstFocusableElement = () =>
    panel.querySelector('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');

  const closeMenu = () => {
    header.classList.remove('is-mobile-nav-open');
    document.body.classList.remove('is-mobile-nav-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    panel.hidden = true;
  };

  const openMenu = () => {
    closeSearch();
    header.classList.add('is-mobile-nav-open');
    document.body.classList.add('is-mobile-nav-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    panel.hidden = false;

    const firstFocusableElement = getFirstFocusableElement();

    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  };

  toggle.addEventListener('click', () => {
    if (header.classList.contains('is-mobile-nav-open')) {
      closeMenu();
      return;
    }

    openMenu();
  });

  panel.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  if (panel) {
    panel.addEventListener('click', (event) => {
      const submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
      if (submenuToggle) {
        event.preventDefault();
        event.stopPropagation();
        const expanded = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', String(!expanded));
        
        const navItem = submenuToggle.closest('.site-header__mobile-nav-item');
        if (navItem) {
          const children = navItem.querySelector('.site-header__mobile-nav-children');
          if (children) {
            children.hidden = expanded;
          }
        }
      }
    });
  }

  searchToggles.forEach((searchToggle) => {
    searchToggle.addEventListener('click', (event) => {
      if (panel.contains(event.currentTarget)) {
        closeMenu();
      }

      if (header.classList.contains('is-search-open')) {
        closeSearch({ returnFocus: true });
        return;
      }

      openSearch(searchToggle);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      closeMenu();
      toggle.focus();
    });
  }

  document.addEventListener('click', (event) => {
    if (!header.classList.contains('is-mobile-nav-open')) {
      if (!header.classList.contains('is-search-open')) {
        return;
      }
    }

    if (header.contains(event.target)) {
      return;
    }

    if (header.classList.contains('is-mobile-nav-open')) {
      closeMenu();
    }

    if (header.classList.contains('is-search-open')) {
      closeSearch();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (header.classList.contains('is-mobile-nav-open')) {
        closeMenu();
        toggle.focus();
      }

      if (header.classList.contains('is-search-open')) {
        closeSearch({ returnFocus: true });
      }
    }
  });

  const desktopMediaQuery = window.matchMedia('(min-width: 990px)');
  const handleBreakpointChange = (event) => {
    if (event.matches) {
      closeMenu();
      closeSearch();
    }
  };

  if (desktopMediaQuery.addEventListener) {
    desktopMediaQuery.addEventListener('change', handleBreakpointChange);
  } else {
    desktopMediaQuery.addListener(handleBreakpointChange);
  }
});
